import { Badge } from "@/components/ui/badge";
import type { ProjectAccess } from "@/lib/project-access";
import { cn } from "@/lib/utils";

interface ProjectAccessChipProps {
  access: ProjectAccess;
  /** Layout from the host: where it sits, and when it hides for lack of room. */
  className?: string;
}

/**
 * What the user is to a project, in one word. A text line tall, so a row or
 * heading that holds it does not grow. The host decides the level and when to
 * show it. See [[project-access-chip.spec]].
 */
export function ProjectAccessChip({ access, className }: ProjectAccessChipProps) {
  return (
    <Badge
      variant="secondary"
      data-testid="project-access-chip"
      className={cn("h-4 px-1.5 py-0 text-[10px] leading-none", className)}
    >
      {access}
    </Badge>
  );
}
